import { SliceClass } from 'interfaces';

export class LandingPage {
  url: string;
  slices: SliceClass[];
  title: string;
  metaDescription: string;
  metaRobotsNoIndex: boolean;

  constructor(url: string, slices: SliceClass[], title: string, metaDescription: string, metaRobotsNoIndex = false) {
    this.url = url;
    this.slices = slices;
    this.title = title;
    this.metaDescription = metaDescription;
    this.metaRobotsNoIndex = metaRobotsNoIndex;

    if (this.slices[0]) {
      this.slices[0].isHeadSlice = true;
    }
  }
}
